export default __webpack_public_path__ + "static/media/edit_info_icon.6490b44c.png";